// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PracticeDiagnosisResponse } from './practice-diagnosis-response';

/** See com.rev360.pms.api.controller.patient.pod.PatientPodPersonDiagnosisResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPodPersonDiagnosisResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	diagnosisDate!: Date;

	@GandalfConstantDecorator(constants.DiagnosisLocation)
	@GandalfProperty({ designType: constants.DiagnosisLocation })
	diagnosisLocation!: constants.DiagnosisLocation | null;

	@GandalfConstantDecorator(constants.DiagnosisLocationQualifier)
	@GandalfProperty({ designType: constants.DiagnosisLocationQualifier })
	diagnosisLocationQualifier!: constants.DiagnosisLocationQualifier | null;

	@GandalfProperty({ designType: Boolean })
	needConversion!: boolean;

	@GandalfProperty({ designType: Number })
	personDiagnosisId!: number;

	@GandalfProperty({ designType: PracticeDiagnosisResponse })
	practiceDiagnosis!: PracticeDiagnosisResponse;

	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfProperty({ designType: Boolean })
	showDisabledWarning!: boolean;

	@GandalfConstantDecorator(constants.PersonDiagnosisStatus)
	@GandalfProperty({ designType: constants.PersonDiagnosisStatus })
	status!: constants.PersonDiagnosisStatus;

	@GandalfProperty({ designType: Date })
	updatedOn!: Date | null;

}
